import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type { Select2Option } from '@/components/forms/Select2';
import type {
  ApiLoginsRow,
  ChangePasswordRequest,
  CreditTransactionRequest,
  OnlineManagerFilterInput,
  TransactionRequest,
} from '@/api/types/onlineManager';

// Finkit.OnlineManager.OnlineManagerAppService -> /api/app/online-manager.
const BASE = '/api/app/online-manager';

// GetOperationTypes etc. return List<ResultDto<int>> ({ value, text }).
interface EnumResult {
  value: number;
  text: string;
}
const toOptions = (rows: EnumResult[]): Select2Option[] => rows.map((r) => ({ value: r.value, label: r.text }));

export const onlineManagerApi = {
  getRows: (input: OnlineManagerFilterInput) =>
    http.get<PagedResult<ApiLoginsRow>>(`${BASE}/for-data-table`, { params: input }).then((r) => r.data),
  getConnectorWarning: () =>
    http.get<{ message?: string | null }>(`${BASE}/connector-warning`).then((r) => r.data),
  getOperationTypes: () =>
    http.get<EnumResult[]>(`${BASE}/operation-types`).then((r) => toOptions(r.data)),
  getCreditOperationTypes: () =>
    http.get<EnumResult[]>(`${BASE}/credit-operation-types`).then((r) => toOptions(r.data)),
  getPasswordTypes: () =>
    http.get<EnumResult[]>(`${BASE}/password-types`).then((r) => toOptions(r.data)),
  addTransaction: (body: TransactionRequest) =>
    http.post(`${BASE}/deposit-or-withdrawal`, body).then((r) => r.data),
  addCreditTransaction: (body: CreditTransactionRequest) =>
    http.post(`${BASE}/credit-transaction`, body).then((r) => r.data),
  changePassword: (body: ChangePasswordRequest) =>
    http.post(`${BASE}/change-password`, body).then((r) => r.data),
};
